@use 'themes/westfield' as *;
@use 'tools/fonts' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;

@import '../../../scentregroup-ui/tools/reset.css';

@mixin inlineLinkRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 48px;
  gap: 8px;

  a {
    height: 48px;
    line-height: 48px;
    vertical-align: middle;
    display: inline-block;
  }
}

:global {
  body {
    @include ceraPro;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}

.terms {
  &,
  a {
    color: #1c1f24;
  }
}

.intro {
  padding-bottom: units(1.5);
  color: #1c1f24;
}

.login {
  &,
  a {
    color: #1c1f24;
  }
}

.loginText {
  @include inlineLinkRow;
  color: #1c1f24;
  margin-bottom: units(1.5);
}

.emailField label {
  font-weight: normal;
}

.submitButtonWrapper {
  display: flex;
  flex-flow: column;
}
